import React from 'react';
import { Button, Modal } from '@efast_public/fjd-component-library';

export interface IConfirmationModalProps {
  readonly confirmationButtonLabel: string;
  readonly abortButtonLabel: string;
  readonly confirmationHeading: string;
  readonly onConfirm: () => void;
  readonly onAbort: () => void;
  readonly isConfirmationModalVisible: boolean;
  readonly 'data-testid'?: string;
  readonly content?: React.ReactNode;
}

export function ConfirmationModal({
  confirmationHeading,
  confirmationButtonLabel,
  abortButtonLabel,
  onConfirm,
  onAbort,
  isConfirmationModalVisible,
  'data-testid': dataTestId,
  content
}: IConfirmationModalProps) {
  return (
    <Modal
      closeOnBackdropClick
      open={isConfirmationModalVisible}
      onClose={onAbort}
    >
      <Modal.Header id="ConfirmationModal-header">
        {confirmationHeading}
      </Modal.Header>

      <Modal.Content>{content}</Modal.Content>
      <Modal.Footer direction="rtl" alignment="none">
        <Button size="sm" variant="secondary-outline" onClick={onAbort}>
          {abortButtonLabel}
        </Button>
        <Button size="sm" variant="primary" onClick={onConfirm}>
          {confirmationButtonLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
